import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core/auth/auth.service';

@Component({
  selector: 'vex-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.getDomain() // Verifica la sesión al inicio
      .then(() => {
        this.authService.initializeSession();
      })
      .catch((error) => {
        // Error al verificar la sesión - manejado silenciosamente
      });
  }

  getDomain(): Promise<void> {
    return new Promise((resolve, reject) => {
      // Obtener el dominio actual
      let fullDomain = `${window.location.protocol}//${window.location.hostname}`;

      if(fullDomain === 'http://localhost') {
        fullDomain = `${fullDomain}:${window.location.port}`;
      }

      sessionStorage.setItem('domain', fullDomain);

      resolve();
    });
  }
}
